import { render } from "./ApplicationAcknowledgment.vue?vue&type=template&id=13a0f617"
import script from "./ApplicationAcknowledgment.vue?vue&type=script&lang=js"
export * from "./ApplicationAcknowledgment.vue?vue&type=script&lang=js"

import "./ApplicationAcknowledgment.vue?vue&type=style&index=0&id=13a0f617&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__